module.exports = __webpack_public_path__ + "img/u10.db6087ee.png";